<script>
import Layout from "../../layouts/main";
import appConfig from "@/app.config";
import PageHeader from "@/components/page-header";
import simplebar from "simplebar-vue";
import ApiClass from "../../api/api";
/**
 * Lending component
 */
export default {
  page: {
    title: "KYC Verification",
    meta: [{ name: "description", content: appConfig.description }],
  },
  components: { Layout, PageHeader, simplebar },
  data() {
    return {
      title: "KYC Verification",
      items: [
        {
          text: "KYC",
          href: "/admin",
        },
        {
          text: "Complete",
          active: true,
        },
      ],
      loading: false,
      totalRows: 0,
      currentRowData: "",
      currentPage: 1,
      perPage: 5,
      sortBy: "value",
      largeImg: "",
      sortDesc: false,
      fields: [
        {
          key: "id",
          value: "#",
          sortable: true,
        },
        {
          key: "FirstName",
          value: "fname",
          sortable: true,
        },
        {
          key: "MiddleName",
          value: "Middel Name",
          sortable: true,
        },
        {
          key: "LastName",
          value: "Last Name",
          sortable: true,
        },
        {
          key: "DateOfBirth",
          value: "Date Of Birth",
          sortable: true,
        },
        {
          key: "Address",
          value: "Address",
          sortable: true,
        },
        {
          key: "mobile",
          sortable: true,
        },
        {
          key: "Document",
          sortable: true,
        },
      ],
    };
  },
  methods: {
    async myProvider(ctx = null, callback) {
      this.loading = !this.loading;
      await ApiClass.getRequest(
        "admin/userkyc/get?status=completed&per_page=" +
          ctx.perPage +
          "&page=" +
          ctx.currentPage,
        true
      ).then((res) => {
        if (res.data.status_code == 1) {
          this.loading = !this.loading;
          const items = res.data.data ? res.data.data.data : [];
          console.log(items);
          this.currentPage = res.data.data ? res.data.data.current_page : "";
          this.totalRows = res.data.data ? res.data.data.total : "";
          callback(items);
        }
      }).bind(this);
    },
    onclose() {
      this.$root.$emit("bv::hide::modal", "modal-center");
    },
  }
}
</script>

<template>
  <Layout>
    <PageHeader :title="title" :items="items" />

    <div class="row">
      <div class="col-md-12">
        <div class="card">
          <div class="card-body">
            <h4 class="card-title mb-4">KYC Requests</h4>
            <simplebar style="max-height: 600px">
              <div class="table-responsive">
                <b-table
                  :items="myProvider"
                  :fields="fields"
                  responsive="sm"
                  :per-page="perPage"
                  :current-page="currentPage"
                  :sort-by.sync="sortBy"
                  :sort-desc.sync="sortDesc"
                  :busy="loading"
                  ref="table"
                  show-empty
                >
                  <template #empty>
                    <div class="d-flex justify-content-center mb-3">
                      No Record Found
                    </div>
                  </template>

                  <template #table-busy>
                    <div class="text-center text-info my-2">
                      <b-spinner class="align-middle"></b-spinner>
                      <!-- <strong>Loading...</strong> -->
                    </div>
                  </template>

                  <template v-slot:cell(id)="data">
                    <div v-if="data.item.user.id">
                      {{ data.item.user.id }}
                    </div>
                  </template>

                  <template v-slot:cell(FirstName)="data">
                    <div v-if="data.item.first_name">
                      {{ data.item.first_name }}
                    </div>
                  </template>

                  <template v-slot:cell(MiddleName)="data">
                    <div v-if="data.item.middle_name">
                      {{ data.item.middle_name }}
                    </div>
                  </template>

                  <template v-slot:cell(LastName)="data">
                    <div v-if="data.item.last_name">
                      {{ data.item.last_name }}
                    </div>
                  </template>

                  <template v-slot:cell(DateOfBirth)="data">
                    <div v-if="data.item.date_birth">
                      {{ data.item.date_birth }}
                    </div>
                  </template>

                  <template v-slot:cell(Address)="data">
                    <div v-if="data.item.address">
                      {{ data.item.address }}
                    </div>
                  </template>

                  <template v-slot:cell(mobile)="data">
                    <div v-if="data.item.user.mobile">
                      {{ data.item.user.mobile }}
                    </div>
                  </template>

                  <template v-slot:cell(Document)="data">
                    <b-button
                      v-b-modal.modal-center
                      variant="white"
                      @click="currentRowData = data.item"
                      class="btn btn-primary btn-sm w-xs"
                      >View</b-button
                    >
                  </template>
                </b-table>
              </div>
              <div class="row m-0">
                <div class="col p-0">
                  <div
                    class="dataTables_paginate paging_simple_numbers float-end"
                  >
                    <ul class="pagination pagination-rounded mb-0">
                      <!-- pagination -->
                      <b-pagination
                        v-model="currentPage"
                        :total-rows="totalRows"
                        :per-page="perPage"
                      ></b-pagination>
                    </ul>
                  </div>
                </div>
              </div>
            </simplebar>
          </div>
          <b-modal
            id="modal-center"
            size="xl"
            centered
            title="KYC INFORMATION"
            title-class="font-18 text-dark"
            hide-footer
            v-if="currentRowData"
          >
            <!-- Identity Module -->
            <b-row align-v="center">
              <b-col md="12">
                <div class="label_addhar_box">
                  <table class="table table-bordered">
                    <tr>
                      <td><label for="">UserID  :</label></td>
                      <td>
                        <label for="">{{
                          currentRowData.user.username
                        }}</label>
                      </td>
                    </tr>
                    <tr>
                      <td><label for="">User Email :</label></td>
                      <td>
                        <label for="">{{
                          currentRowData.user.email
                        }}</label>
                      </td>
                    </tr>
                    <tr>
                      <td><label for="">Identity Type :</label></td>
                      <td>
                        <label for="">{{
                          currentRowData.identity_type
                        }}</label>
                      </td>
                    </tr>
                    <tr>
                      <td><label for="">Identity No. :</label></td>
                      <td>
                        <label for="">{{
                          currentRowData.identity_number
                        }}</label>
                      </td>
                    </tr>
                    <tr>
                      <td><label for="">Status :</label></td>
                      <td  v-if="currentRowData.is_identity_verify == 1">
                          <span class="success">Approved</span>
                       
                      </td>
                    </tr>
                  </table>
                </div>
              </b-col>
              <!--Label-->
              <b-col md="6">
                <div class="front_image">
                  <img
                    v-b-modal.modal-1
                    @click="largeImg = currentRowData.identity_front_path"
                    :src="currentRowData.identity_front_path"
                    loading="lazy"
                    class="img-fluid img-thumbnail"
                    alt="front_image"
                  />
                </div>
              </b-col>
              <!--Font Image-->
              <b-col md="6">
                <div class="back_image">
                  <img
                    v-b-modal.modal-1
                    @click="largeImg = currentRowData.identity_back_path"
                    :src="currentRowData.identity_back_path"
                    loading="lazy"
                    class="img-fluid img-thumbnail"
                    alt="front_image"
                  />
                </div>
              </b-col>
              <!--Back images-->

            

              <!--Back images-->
            </b-row>
            <hr />

           
          </b-modal>

          <!-- Large Image Modal -->
          <b-modal id="modal-1" size="lg" v-if="largeImg">
            <b-row align-v="center">
              <img
                :src="largeImg"
                loading="lazy"
                class="img-fluid img-thumbnail"
                alt="front_image"
              />
            </b-row>
            <template #modal-footer>
              <p></p>
            </template>
          </b-modal>
        </div>
      </div>
    </div>
    <!-- end row -->
  </Layout>
</template>


<style scoped>

.succ_btn {
  float: right;
  clear: both;
  margin: 20px 0px;
}
.clr-red {
  color: red;
}
.success {
  color: green;
  font-weight: 600;
  font-size: 14px;
}
</style>